const formatParenthesis = (text) => {
  if (!text || (!text.includes('(') && !text.includes(')'))) {
    return text;
  }
  return text.replace(/\(/g, "&lpar;").replace(/\)/g, "&rpar;");
}

const formatFormDataParenthesis = (formData) => {
  for(const [fieldName, fieldValue] of formData.entries()) {
    if (typeof fieldValue === 'string' && (fieldValue.includes('(') || fieldValue.includes(')'))) {
      formData.set(fieldName, formatParenthesis(fieldValue));
    }
  }
}

export {
  formatParenthesis,
  formatFormDataParenthesis,
};
